export default function isGraphicAccelerationEnabled() {
  try {
    // Create a canvas element to test WebGL
    const canvas = document.createElement('canvas');
    const gl =
      canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

    if (!gl) {
      return false;
    }

    // Check for WebGL debug renderer info extension
    const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
    if (debugInfo) {
      const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
      // Check if renderer indicates hardware acceleration
      // Software renderers typically contain "llvmpipe", "Microsoft Basic Render Driver", "SwiftShader" etc.
      const softwareRenderers = [
        'llvmpipe',
        'microsoft basic render driver',
        'swiftshader',
        'software'
      ];
      const isHardwareAccelerated = !softwareRenderers.some(software =>
        renderer.toLowerCase().includes(software)
      );
      return isHardwareAccelerated;
    }

    // If we can create WebGL context but can't get renderer info,
    // assume hardware acceleration is available
    return true;
  } catch (error) {
    console.warn('Error detecting graphic acceleration:', error);
    return false;
  }
}
